import { createSelector } from '@reduxjs/toolkit';
import { generateLadder } from '../utils/generate-ladder';

// Selectors for state slices
export const selectPredictions = (state) => state.ladderPredictor.predictions;
export const selectTeams = (state) => state.ladderPredictor.teams;
export const selectPreviousLadder = (state) =>
    state.ladderPredictor.previousLadder;
export const selectFirstCutOff = (state) => state.ladderPredictor.firstCutOff;
export const selectSecondCutOff = (state) => state.ladderPredictor.secondCutOff;

// Memoized selector for generating the ladder
export const selectLadder = createSelector(
    [selectPredictions, selectTeams, selectPreviousLadder],
    (predictions, teams, previousLadder) => {
        // Generate the current ladder using utility function
        return generateLadder(predictions, teams, previousLadder);
    }
);

// Memoized selector for cutoffs
export const selectCutoffs = createSelector(
    [selectFirstCutOff, selectSecondCutOff],
    (firstCutOff, secondCutOff) => ({
        firstCutOff,
        secondCutOff
    })
);
